module.exports = __webpack_public_path__ + "img/fourday_ps_05.aec6e6e7.jpg";